export enum APOLLO_CLIENT {
  PORTAL_CLIENT = 'PORTAL_CLIENT',
  HEATING_SYSTEM_COLLECTOR_CLIENT = 'HEATING_SYSTEM_COLLECTOR_CLIENT',
}
